export default function PosHomeIcon({ className }: any) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M6.66667 17.0127C6.66667 15.2024 6.66667 14.2972 7.03261 13.5016C7.39856 12.7059 8.08582 12.1168 9.46034 10.9387L10.7937 9.79582C13.2781 7.66632 14.5203 6.60156 16 6.60156C17.4797 6.60156 18.7219 7.66632 21.2063 9.79582L22.5397 10.9387C23.9142 12.1168 24.6014 12.7059 24.9674 13.5016C25.3333 14.2972 25.3333 15.2024 25.3333 17.0127V22.6666C25.3333 25.1807 25.3333 26.4378 24.5523 27.2189C23.7712 27.9999 22.5142 27.9999 20 27.9999H12C9.48584 27.9999 8.22876 27.9999 7.44771 27.2189C6.66667 26.4378 6.66667 25.1807 6.66667 22.6666V17.0127Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19.3333 28V21C19.3333 20.4477 18.8856 20 18.3333 20H13.6667C13.1144 20 12.6667 20.4477 12.6667 21V28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
